module.exports = __webpack_public_path__ + "components/flag/static/square/mp-63c31c8317fb91c9c6104be0bb4ac433.svg";